import { render, staticRenderFns } from "./selfPickupGoodsRiderOrderDetail.vue?vue&type=template&id=382ebdd2&scoped=true"
import script from "./selfPickupGoodsRiderOrderDetail.vue?vue&type=script&lang=js"
export * from "./selfPickupGoodsRiderOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./selfPickupGoodsRiderOrderDetail.vue?vue&type=style&index=0&id=382ebdd2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382ebdd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382ebdd2')) {
      api.createRecord('382ebdd2', component.options)
    } else {
      api.reload('382ebdd2', component.options)
    }
    module.hot.accept("./selfPickupGoodsRiderOrderDetail.vue?vue&type=template&id=382ebdd2&scoped=true", function () {
      api.rerender('382ebdd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/selfPickupGoodsRiderOrderDetail.vue"
export default component.exports